import InboxAddPage from './add'
export default InboxAddPage
